module.exports = __webpack_public_path__ + "img/time_line_circular_connect_head.ffd47cf9.svg";